<template>
  <div class="pub-col">
    <div
      class="pub-circle"
      :class="{ 'pub-circle--filled': preview, 'pub-circle--error': hasError }"
      @click="$emit('click')"
      role="button"
      :title="preview ? 'Trocar foto' : label"
    >
      <img v-if="preview" :src="preview" alt="Prévia" />
      <div v-else class="pub-circle__empty">
        <i class="fas fa-camera"></i>
        <span>{{ emptyLabel }}</span>
      </div>
      <div v-if="preview" class="pub-circle__overlay">
        <i class="fas fa-camera"></i>
      </div>
    </div>

    <button
      v-if="preview && showRemove"
      type="button"
      class="pub-remove"
      @click.stop="$emit('remove')"
      title="Remover foto"
    >
      <i class="fas fa-trash-alt"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'PhotoUploadButton',
  props: {
    preview: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: 'Adicionar foto',
    },
    emptyLabel: {
      type: String,
      default: 'Foto',
    },
    showRemove: {
      type: Boolean,
      default: true,
    },
    hasError: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['click', 'remove'],
};
</script>

<style scoped>
.pub-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.pub-circle {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  overflow: hidden;
  background: #f8f8f8;
  border: 2.5px dashed #d0d0d0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  transition: border-color 0.2s;
}

.pub-circle:hover {
  border-color: #ff50a3;
}

.pub-circle--filled {
  border-style: solid;
  border-color: #ff50a3;
}

.pub-circle--error {
  border-color: #dc3545;
}

.pub-circle img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.pub-circle__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 3px;
  color: #c0c0c0;
  font-size: 0.65rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.pub-circle__empty i {
  font-size: 1.2rem;
}

.pub-circle__overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.42);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.18s;
  color: #fff;
  font-size: 1rem;
}

.pub-circle:hover .pub-circle__overlay {
  opacity: 1;
}

.pub-remove {
  background: none;
  border: none;
  color: #dc3545;
  font-size: 0.72rem;
  cursor: pointer;
  padding: 2px 4px;
  transition: opacity 0.18s;
}

.pub-remove:hover {
  opacity: 0.7;
}
</style>
